import React, { createContext, useContext, useState } from "react";
import AdvancedFilters from "../../v1/components/filters/AdvanceFilters";

type FiltersType = Partial<AdvancedFilters>;

interface FiltersContextType {
  filters: FiltersType;
  setFilters: (filters: FiltersType) => void;
}

const FiltersContext = createContext<FiltersContextType | undefined>(undefined);

export const FiltersProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [filters, setFilters] = useState<FiltersType>({});
  return (
    <FiltersContext.Provider value={{ filters, setFilters }}>
      {children}
    </FiltersContext.Provider>
  );
};

export const useFilters = () => {
  const context = useContext(FiltersContext);
  if (!context) {
    throw new Error("useFilters must be used within FiltersProvider");
  }
  return context;
};
